/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BaseResponseWithTimezone,
  TenantDomainBindingListResponse,
  TenantDomainBindingResponse,
} from '../models/index';
import {
    BaseResponseWithTimezoneFromJSON,
    BaseResponseWithTimezoneToJSON,
    TenantDomainBindingListResponseFromJSON,
    TenantDomainBindingListResponseToJSON,
    TenantDomainBindingResponseFromJSON,
    TenantDomainBindingResponseToJSON,
} from '../models/index';

export interface BindTenantRequest {
    customerId: string;
    domainMappingId: string;
    tenantId: string;
    primary?: boolean;
    sessionId?: string;
}

export interface ListBindings1Request {
    customerId: string;
    domainMappingId: string;
    sessionId?: string;
}

export interface SetPrimaryRequest {
    customerId: string;
    domainMappingId: string;
    tenantId: string;
    sessionId?: string;
}

export interface UnbindTenantRequest {
    customerId: string;
    domainMappingId: string;
    tenantId: string;
    sessionId?: string;
}

/**
 * TenantDomainBindingsApi - interface
 * 
 * @export
 * @interface TenantDomainBindingsApiInterface
 */
export interface TenantDomainBindingsApiInterface {
    /**
     * Bind a tenant to a domain for a customer. Optionally mark as primary to prefer this tenant on landing for this domain.
     * @summary Bind tenant
     * @param {string} customerId Customer ID
     * @param {string} domainMappingId Domain Mapping ID
     * @param {string} tenantId Tenant ID
     * @param {boolean} [primary] Set as primary binding
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantDomainBindingsApiInterface
     */
    bindTenantRaw(requestParameters: BindTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDomainBindingResponse>>;

    /**
     * Bind a tenant to a domain for a customer. Optionally mark as primary to prefer this tenant on landing for this domain.
     * Bind tenant
     */
    bindTenant(requestParameters: BindTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDomainBindingResponse>;

    /**
     * List tenant-domain bindings for a customer and a specific domain mapping. Useful to understand which tenants are served by a domain.
     * @summary List bindings
     * @param {string} customerId Customer ID
     * @param {string} domainMappingId Domain Mapping ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantDomainBindingsApiInterface
     */
    listBindings1Raw(requestParameters: ListBindings1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDomainBindingListResponse>>;

    /**
     * List tenant-domain bindings for a customer and a specific domain mapping. Useful to understand which tenants are served by a domain.
     * List bindings
     */
    listBindings1(requestParameters: ListBindings1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDomainBindingListResponse>;

    /**
     * Mark one tenant binding as primary for this domain. Only one primary is allowed per (customer, domain).
     * @summary Set primary binding
     * @param {string} customerId Customer ID
     * @param {string} domainMappingId Domain Mapping ID
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantDomainBindingsApiInterface
     */
    setPrimaryRaw(requestParameters: SetPrimaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BaseResponseWithTimezone>>;

    /**
     * Mark one tenant binding as primary for this domain. Only one primary is allowed per (customer, domain).
     * Set primary binding
     */
    setPrimary(requestParameters: SetPrimaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BaseResponseWithTimezone>;

    /**
     * Remove a tenant-domain binding. If it was primary, no primary will be set thereafter unless you set one explicitly.
     * @summary Unbind tenant
     * @param {string} customerId Customer ID
     * @param {string} domainMappingId Domain Mapping ID
     * @param {string} tenantId Tenant ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantDomainBindingsApiInterface
     */
    unbindTenantRaw(requestParameters: UnbindTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BaseResponseWithTimezone>>;

    /**
     * Remove a tenant-domain binding. If it was primary, no primary will be set thereafter unless you set one explicitly.
     * Unbind tenant
     */
    unbindTenant(requestParameters: UnbindTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BaseResponseWithTimezone>;

}

/**
 * 
 */
export class TenantDomainBindingsApi extends runtime.BaseAPI implements TenantDomainBindingsApiInterface {

    /**
     * Bind a tenant to a domain for a customer. Optionally mark as primary to prefer this tenant on landing for this domain.
     * Bind tenant
     */
    async bindTenantRaw(requestParameters: BindTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDomainBindingResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling bindTenant().'
            );
        }

        if (requestParameters['domainMappingId'] == null) {
            throw new runtime.RequiredError(
                'domainMappingId',
                'Required parameter "domainMappingId" was null or undefined when calling bindTenant().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling bindTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['primary'] != null) {
            queryParameters['primary'] = requestParameters['primary'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/domains/{domainMappingId}/bindings/{tenantId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"domainMappingId"}}`, encodeURIComponent(String(requestParameters['domainMappingId'])));
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantDomainBindingResponseFromJSON(jsonValue));
    }

    /**
     * Bind a tenant to a domain for a customer. Optionally mark as primary to prefer this tenant on landing for this domain.
     * Bind tenant
     */
    async bindTenant(requestParameters: BindTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDomainBindingResponse> {
        const response = await this.bindTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List tenant-domain bindings for a customer and a specific domain mapping. Useful to understand which tenants are served by a domain.
     * List bindings
     */
    async listBindings1Raw(requestParameters: ListBindings1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantDomainBindingListResponse>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listBindings1().'
            );
        }

        if (requestParameters['domainMappingId'] == null) {
            throw new runtime.RequiredError(
                'domainMappingId',
                'Required parameter "domainMappingId" was null or undefined when calling listBindings1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/domains/{domainMappingId}/bindings`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"domainMappingId"}}`, encodeURIComponent(String(requestParameters['domainMappingId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantDomainBindingListResponseFromJSON(jsonValue));
    }

    /**
     * List tenant-domain bindings for a customer and a specific domain mapping. Useful to understand which tenants are served by a domain.
     * List bindings
     */
    async listBindings1(requestParameters: ListBindings1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantDomainBindingListResponse> {
        const response = await this.listBindings1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark one tenant binding as primary for this domain. Only one primary is allowed per (customer, domain).
     * Set primary binding
     */
    async setPrimaryRaw(requestParameters: SetPrimaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BaseResponseWithTimezone>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling setPrimary().'
            );
        }

        if (requestParameters['domainMappingId'] == null) {
            throw new runtime.RequiredError(
                'domainMappingId',
                'Required parameter "domainMappingId" was null or undefined when calling setPrimary().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling setPrimary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/domains/{domainMappingId}/bindings/{tenantId}/primary`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"domainMappingId"}}`, encodeURIComponent(String(requestParameters['domainMappingId'])));
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseResponseWithTimezoneFromJSON(jsonValue));
    }

    /**
     * Mark one tenant binding as primary for this domain. Only one primary is allowed per (customer, domain).
     * Set primary binding
     */
    async setPrimary(requestParameters: SetPrimaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BaseResponseWithTimezone> {
        const response = await this.setPrimaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Remove a tenant-domain binding. If it was primary, no primary will be set thereafter unless you set one explicitly.
     * Unbind tenant
     */
    async unbindTenantRaw(requestParameters: UnbindTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BaseResponseWithTimezone>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling unbindTenant().'
            );
        }

        if (requestParameters['domainMappingId'] == null) {
            throw new runtime.RequiredError(
                'domainMappingId',
                'Required parameter "domainMappingId" was null or undefined when calling unbindTenant().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling unbindTenant().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/customers/{customerId}/domains/{domainMappingId}/bindings/{tenantId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"domainMappingId"}}`, encodeURIComponent(String(requestParameters['domainMappingId'])));
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseResponseWithTimezoneFromJSON(jsonValue));
    }

    /**
     * Remove a tenant-domain binding. If it was primary, no primary will be set thereafter unless you set one explicitly.
     * Unbind tenant
     */
    async unbindTenant(requestParameters: UnbindTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BaseResponseWithTimezone> {
        const response = await this.unbindTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
